"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Parse = require("parse/node");
var QuoteType;
(function (QuoteType) {
    QuoteType["Generic"] = "RETAILER";
    QuoteType["User"] = "USER";
    QuoteType["Team"] = "TEAM";
})(QuoteType = exports.QuoteType || (exports.QuoteType = {}));
class Quote extends Parse.Object {
    constructor(attributes) {
        super('Quote', attributes);
    }
    /** the text that will be exported to the customer */
    get text() { return this.get('text'); }
    set text(value) { this.set('text', value); }
    /** the title of this quote */
    get title() { return this.get('title'); }
    set title(value) { this.set('title', value); }
    /** the associated that owns this association */
    get retailer() { return this.get('retailer'); }
    set retailer(value) { this.set('retailer', value); }
    /** the title of this quote */
    get type() { return this.get('type'); }
    set type(value) { this.set('type', value); }
}
exports.Quote = Quote;
Parse.Object.registerSubclass('Quote', Quote);
//# sourceMappingURL=Quote.js.map